// 系统配置管理
import {contractApi} from "@/axios";
//获取系统配置信息
export function getConfigPage(params,data){
    return contractApi({
        url:'/sys-config/page',
        method:'get',
        data:data,
        params:params
    })
}
//删除系统配置信息
export function deleteConfig(params){
    return contractApi({
        url:'/sys-config',
        method:'delete',
        params:params
    })
}
//添加系统配置信息
export function addConfig(data){
    return contractApi({
        url:'/sys-config',
        method:'post',
        data:data
    })
}
//修改系统配置信息
export function editConfig(data){
    return contractApi({
        url:'/sys-config',
        method:'put',
        data:data
    })
}